import type { DomainMapper } from '../types';

const dk: DomainMapper = {
  countryCode: 'dk',
  currency: 'DKK',
  dataAreaId: 'se01',
  domain: 'kahrs-stage.iveo.store',
  environment: 'stage',
  flagUrl: '/flags/DK.svg',
  languagePrimary: true,
  locale: 'da',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'produkt',
  sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-dk.xml',
  storyblokBasePath: 'dk',
  url: 'https://kahrs-stage.iveo.store/dk',
  algoliaIndex: 'b2b-dk-da-DK-products',
  algoliaIndexAutocomplete: 'b2b-dk-da-DK-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1453,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1453,
    algoliaIndex: 'b2b-dk-da-DK-products',
    algoliaIndexAutocomplete: 'b2b-dk-da-DK-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-dk.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1471,
    algoliaIndex: 'b2c-dk-da-DK-products',
    algoliaIndexAutocomplete: 'b2c-dk-da-DK-products_query_suggestions',
    displayIncVat: true,
    default: false,
    productBasePath: 'produkt',
    sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-dk-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
  },
  showNonPublicProducts: true,
  norceCdnBaseUrl: 'https://kahrs.stage.cdn-norce.tech',
} as DomainMapper;

export default dk;
